import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Select, Input, Button, message, Typography } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";
import { useTranslation } from "react-i18next";
import HomeButton from "../components/HomeButton";

const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

const MachineTranslation: React.FC = () => {
  const { t } = useTranslation();
  const [translatedText, setTranslatedText] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleTranslation = async (values: {
    texts: string;
    lang_type: string;
    trg_lang: string;
  }) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/zhadiger/api/mt`,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      setTranslatedText(response.data);
      message.success(t("translation_successful"));
    } catch (error) {
      message.error("Error translating text");
      console.error("Error in Translation API call:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 ml-4 pt-4 ">
        <HomeButton />
      </div>
      <div className="max-w-xl mx-auto mt-10 p-6 bg-white border border-gray-200 rounded-lg shadow-md flex-grow">
        <Title level={2} className="text-center font-bold text-gray-700">
          {t("machine_translation")}
        </Title>

        <Formik
          initialValues={{ texts: "", lang_type: "en", trg_lang: "ru" }}
          onSubmit={handleTranslation}
        >
          {({ handleSubmit }) => (
            <Form className="space-y-4">
              <Field name="texts">
                {({ field }: { field: any }) => (
                  <TextArea
                    {...field}
                    placeholder={t("enter_the_text")}
                    rows={4}
                    disabled={loading}
                    className="p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                )}
              </Field>

              <div className="flex space-x-4">
                <Field name="lang_type">
                  {({ field }: { field: any }) => (
                    <Select
                      {...field}
                      onChange={(value) =>
                        field.onChange({ target: { name: field.name, value } })
                      }
                      disabled={loading}
                      className="w-full"
                    >
                      <Option value="ru">Русский</Option>
                      <Option value="kk">Қазақша</Option>
                      <Option value="en">English</Option>
                      <Option value="eng_Latn">English (Latin)</Option>
                      <Option value="tr">Turkish (Latin)</Option>
                    </Select>
                  )}
                </Field>

                <Field name="trg_lang">
                  {({ field }: { field: any }) => (
                    <Select
                      {...field}
                      onChange={(value) =>
                        field.onChange({ target: { name: field.name, value } })
                      }
                      disabled={loading}
                      className="w-full"
                    >
                      <Option value="ru">Русский</Option>
                      <Option value="kk">Қазақша</Option>
                      <Option value="en">English</Option>
                      <Option value="eng_Latn">English (Latin)</Option>
                      <Option value="tr">Turkish (Latin)</Option>
                    </Select>
                  )}
                </Field>
              </div>

              <Button
                type="primary"
                onClick={() => handleSubmit()}
                loading={loading}
                className="w-full bg-blue-500 text-white hover:bg-blue-600 rounded-lg py-2 transition duration-200"
              >
                {t("translate")}
              </Button>
            </Form>
          )}
        </Formik>

        {translatedText && (
          <div className="mt-6 text-center">
            <Title level={4} className="text-gray-600">
              {t("translated_text")}:
            </Title>
            <p className="mt-3 p-3 bg-gray-100 border border-gray-300 rounded-lg">
              {translatedText}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default MachineTranslation;
